var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 8.2a8.84 8.84 0 0 0 8 5.2 8.84 8.84 0 0 0 8-5.2A8.84 8.84 0 0 0 9 3a8.84 8.84 0 0 0-8 5.2h0Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.04 5.4a2.8 2.8 0 1 0 2.7 2.26 2 2 0 0 1-2.7-2.26Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgEye;